import React from 'react';
import { useChatStore } from '../../stores/useChatStore';
import './UsageBadge.css';

export default function UsageBadge() {
  const { usage, sessions } = useChatStore();
  if (!usage) return null;

  const totalCost = sessions.reduce((sum, s) => sum + (s.totalCostUsd || 0), 0);
  const lowRemaining = usage.remaining <= 2;

  return (
    <div className={`usage-badge ${lowRemaining ? 'warn' : ''}`}>
      <span className="usage-badge-count">
        {usage.remaining}/{usage.limit}
      </span>
      <span className="usage-badge-label">heute übrig</span>
      <span className="usage-badge-sep">·</span>
      <span className="usage-badge-cost">${totalCost.toFixed(4)}</span>
    </div>
  );
}
